
import React from 'react';

export default function AboutStats() {
  const stats = [
    {
      number: '200+',
      label: 'Projects Completed',
      description: 'Residential and commercial renovations across Johannesburg',
    },
    {
      number: '10+',
      label: 'Years Experience',
      description: 'Delivering luxury transformations in Gauteng',
    },
    {
      number: '98%',
      label: 'Client Satisfaction',
      description: 'Based on post-project client surveys',
    },
    {
      number: '100%',
      label: 'On-Time Record',
      description: 'Consistent delivery within agreed timelines',
    },
  ];

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center space-y-2 md:space-y-3">
              <p className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#D4AF37]">
                {stat.number}
              </p>
              <p className="text-sm sm:text-base lg:text-lg font-semibold text-[#2A2A2A]">
                {stat.label}
              </p>
              <p className="text-xs sm:text-sm text-gray-500">{stat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
